<template>
  <div v-if="showBorrowedFrom || showSharedWith">
    <vs-alert v-if="showBorrowedFrom"
              :active="true"
              color="primary"
              icon-pack="feather"
              icon="icon-link"
              class="mb-2">
      {{ $t('video-reuse.borrowed-from') }}: {{ sourceLabel }}
      <div v-if="sourceChanged" class="text-sm mt-1">
        {{ $t('video-reuse.source-changed') }}
      </div>
    </vs-alert>

    <vs-alert v-if="showSharedWith"
              :active="true"
              color="warning"
              icon-pack="feather"
              icon="icon-users"
              class="mb-2">
      {{ $t('video-reuse.shared-with-count', {count: sharedCount}) }}
      <ul class="text-sm mt-1">
        <li v-for="row in sharing.videoSharedWith" :key="row.id">
          {{ describe(row) }}
        </li>
      </ul>
    </vs-alert>
  </div>
</template>

<script>
export default {
  name: 'BorrowedVideoInfo',
  props: {
    // The getVdoSetTopicSharing result for the topic on screen. null while it
    // is still loading, or for a topic that has never been part of a borrow.
    sharing: {type: Object, default: null},
  },
  computed: {
    showBorrowedFrom() {
      return !!(this.sharing && this.sharing.sourceVdoSetTopic);
    },
    showSharedWith() {
      return !!(this.sharing &&
        this.sharing.videoSharedWith &&
        this.sharing.videoSharedWith.length);
    },
    sharedCount() {
      return this.showSharedWith ? this.sharing.videoSharedWith.length : 0;
    },
    sourceLabel() {
      return this.showBorrowedFrom ? this.describe(this.sharing.sourceVdoSetTopic) : '';
    },
    // Borrowing is a snapshot: once the source uploads a replacement it moves
    // to a new pointer while this topic keeps the one it borrowed. That is
    // correct behaviour, but it looks like a bug to an admin comparing the two
    // screens, so it is stated out loud.
    sourceChanged() {
      if (!this.showBorrowedFrom) return false;
      const source = this.sharing.sourceVdoSetTopic;
      if (this.sharing.videoProvider === 'bunny') {
        return this.sharing.bunnyVideoGuid !== source.bunnyVideoGuid;
      }
      return this.sharing.vdoStreamPath !== source.vdoStreamPath;
    },
  },
  methods: {
    describe(topic) {
      if (!topic) return '';
      const subject = topic.vdoSet && topic.vdoSet.subject ? topic.vdoSet.subject : null;
      const teacher = topic.teacher ?
        `${topic.teacher.firstNameLocal || ''} ${topic.teacher.lastNameLocal || ''}`.trim() : '';
      const parts = [];
      if (subject) parts.push(`${subject.code} ${subject.nameLocal}`);
      if (teacher) parts.push(teacher);
      parts.push(`${topic.no || ''}. ${topic.nameLocal || topic.nameEng || ''}`.trim());
      return parts.filter(Boolean).join(' / ');
    },
  },
};
</script>
